import { Box, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import {
  AdDrawerStyledButton,
  StyledAccordion,
  StyledAccordionDetails,
  StyledAccordionSummary,
} from "./style";
import {
  ArrowDownIcon,
  BoardIcon,
  CreateNewIcon,
  StarIcon,
  TagsIcon,
} from "../../../assets/Icons";
import { useTheme } from "styled-components";
import SelectBoardDropdown from "../selectBoardsDropdown";
import RatingsDropdown from "../ratingsDropdown";
import AddTagPopover from "../../addTagPopover";
import { useDispatch, useSelector } from "react-redux";
import { StyledChip } from "../../../globalStyle";
import {
  adDetailsSelector,
  openBoardDropdownSelector,
} from "../../../store/metadata/selector";
import { MetaDataSagaActions } from "../../../store/metadata/sagas";
import { DiscoveryItem } from "../../../store/discovery/types";
import { SwipeFileListItems } from "../../../store/swipeFile/types";
import { BoardItem, tagItem } from "../../../store/metadata/types";
import { SaveToSwipeLoungeService } from "../../../services/AdServices";
import { discoveryItemsSelector } from "../../../store/discovery/selector";
import { userDetailsSelector } from "../../../store/account/selector";
import { StyledContainedButton } from "../../modals/style";
import { MetaDataReducerAction } from "../../../store/metadata/slice";

const OrganizationBox = ({
  isSwipeFilePage,
  item,
}: {
  isSwipeFilePage: boolean;
  item: DiscoveryItem | SwipeFileListItems;
}) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const [addTagPopupAnchorEl, setAddTagPopupAnchorEl] =
    useState<Element | null>(null);
  const [expanded, setExpanded] = useState(true);
  const adDetailsData = useSelector(adDetailsSelector);
  const discoveryItems = useSelector(discoveryItemsSelector);
  const user = useSelector(userDetailsSelector);
  const openBoardDropdown = useSelector(openBoardDropdownSelector);

  const handleUpdateBoard = async (
    selectedBoardIds: string[],
    removedBoardId: string[]
  ) => {   
     const userDetails = JSON.parse(localStorage.getItem("User") as string); 
            const selectedAd = item || discoveryItems?.data?.find(
      (ad: any) => ad._id === item._id
    );
        const matchUserId = item?.userId === userDetails?._id;

    dispatch(
      MetaDataSagaActions.saveAdToBoards({
        adId: item._id,
        boardIds: selectedBoardIds,
        removeBoardIds: removedBoardId,
      })
    );

    // if (matchUserId) {
    //   dispatch(
    //     MetaDataSagaActions.saveAdToBoards({
    //       adId: item._id,
    //       boardIds: selectedBoardIds,
    //       removeBoardIds: removedBoardId,
    //     })
    //   );
    // } else {
    //   const adPayload = {
    //     title: "",
    //     description: selectedAd?.description ?? "",
    //     libraryId: selectedAd?._id ?? "",
    //     startedRunningDate: selectedAd?.startedRunningDate ?? "",
    //     platforms: selectedAd?.platforms ?? ["manual"],
    //     imageUrls: selectedAd?.imageUrls ?? [],
    //     videoUrls: selectedAd?.videoUrls ?? [],
    //     adTargetSourceURL: selectedAd?.adTargetSourceURL ?? "",
    //     numberOfAdsRunningText: "",
    //     page: {
    //       pageId: "",
    //       name: selectedAd?.page?.name ?? "",
    //       url: selectedAd?.page?.url ?? "",
    //       logo: selectedAd?.page?.logo ?? "",
    //       country: "",
    //     },
    //     isSaved: true,
    //   };
    //   try {
    //     const response: any = await SaveToSwipeLoungeService(adPayload);
    //     const newAdId = response?.data?.data?._id;
    //     if (newAdId) {
    //       dispatch(
    //         MetaDataSagaActions.saveAdToBoards({
    //           adId: newAdId,
    //           boardIds: selectedBoardIds,
    //           removeBoardIds: removedBoardId,
    //         })
    //       );
    //     }
    //   } catch (error) {
    //     console.error("Failed to save to SwipeLounge:", error);
    //   }
    // }
  };

  useEffect(() => {
    dispatch(MetaDataSagaActions.fetchTagLists());
  }, [dispatch]);
  return (
    <>
      <Box>
        <StyledAccordion
          expanded={expanded}
          onChange={() => setExpanded(!expanded)}
        >
          <StyledAccordionSummary
            expandIcon={<ArrowDownIcon />}
            sx={{ padding: "1.25rem" }}
          >
            Organization
          </StyledAccordionSummary>
          <StyledAccordionDetails
            sx={{
              padding: "1.25rem",
              gap: "1.25rem",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
            >
              <Stack direction="row" alignItems="center" gap="0.5rem">
                <BoardIcon fill={theme.colors.gray1} />
                <Typography
                  fontSize="1rem"
                  fontWeight="500"
                  color={theme.colors.gray1}
                >
                  Save to Boards
                </Typography>
              </Stack>

              <Stack
                direction="row"
                alignItems="center"
                width="60%"
                gap="0.75rem"
              >
                {openBoardDropdown || adDetailsData?.board.length > 0 ? (
                  <SelectBoardDropdown
                    showSelectedItemCount={2}
                    selectedBoards={adDetailsData?.board}
                    selectedBoardIds={adDetailsData?.board.map(
                      (item: BoardItem) => item._id
                    )}
                    isDisabled
                    handleUpdateBoard={handleUpdateBoard}
                  />
                ) : (
                  <StyledContainedButton
                    sx={{ paddingInline: "1.875rem" }}
                    onClick={() => {
                      dispatch(
                        MetaDataReducerAction.setOpenBoardDropdown(true)
                      );
                    }}
                  >
                    Save to Board
                  </StyledContainedButton>
                )}
              </Stack>
            </Stack>

            {user?._id !== item?.userId && (
              <Box
                sx={{
                  backgroundColor: theme.colors.gray97,
                  padding: "0.75rem",
                  borderRadius: "8px",
                }}
              >
                <Stack direction="row" alignItems="center" gap="0.5rem">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    fill={theme.colors.gray1}
                  >
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-10h2v6h-2zm0-4h2v2h-2z" />
                  </svg>
                  <Typography>
                    Please Save the Ad to give tags and ratings!
                  </Typography>
                </Stack>
              </Box>
            )}

            {/* {isSwipeFilePage && ( */}
            {user?._id === item?.userId && (
              <>
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Stack direction="row" alignItems="center" gap="0.5rem">
                    <StarIcon />
                    <Typography
                      fontSize="1rem"
                      fontWeight="500"
                      color={theme.colors.gray1}
                    >
                      Rating
                    </Typography>
                  </Stack>
                  <Stack
                    direction="row"
                    alignItems="center"
                    width="60%"
                    gap="0.75rem"
                  >
                    <RatingsDropdown
                      adId={item?._id}
                      ratingValue={
                        adDetailsData?.ratings &&
                        adDetailsData?.ratings[0]?.rating
                      }
                    />
                  </Stack>
                </Stack>

                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Stack direction="row" alignItems="center" gap="0.5rem">
                    <TagsIcon />
                    <Typography
                      fontSize="1rem"
                      fontWeight="500"
                      color={theme.colors.gray1}
                    >
                      Tags
                    </Typography>
                  </Stack>
                  <Stack
                    direction="row"
                    alignItems="center"
                    width="60%"
                    gap="0.75rem"
                  >
                    {adDetailsData?.Tags?.slice(0, 1).map(
                      (tagItem: tagItem) => (
                        <AdDrawerStyledButton
                          key={tagItem._id}
                          disableTouchRipple
                          borderNone={true}
                          sx={{
                            backgroundColor: `${theme.colors.background4} !important`,
                            cursor: "default",
                            maxWidth: "100px",
                            overflow: "hidden",
                            padding: "0.438rem 0.75rem",
                          }}
                        >
                          <Box
                            sx={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              textTransform: "none",
                            }}
                          >
                            {tagItem.name}
                          </Box>
                        </AdDrawerStyledButton>
                      )
                    )}
                    {adDetailsData?.Tags?.length > 1 && (
                      <StyledChip
                        label={`+${adDetailsData.Tags.length - 1}`}
                        onClick={(event: React.MouseEvent<HTMLElement>) => {
                          setAddTagPopupAnchorEl(event.currentTarget);
                        }}
                        sx={{
                          color: theme.colors.white,
                        }}
                      />
                    )}
                    <AdDrawerStyledButton
                      borderNone
                      sx={{
                        backgroundColor: `${theme.colors.background4} !important`,
                        transition: "background-color 0.2s ease",
                        "&:hover": {
                          backgroundColor: `${theme.colors.background3} !important`,
                        },
                        maxWidth: "160px",
                        gap: "0.2rem !important",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                      onClick={(event: React.MouseEvent<HTMLElement>) => {
                        setAddTagPopupAnchorEl(event.currentTarget);
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <CreateNewIcon fill={theme.colors.black2} />
                      </div>
                      <p style={{ textWrap: "nowrap" }}>
                        {adDetailsData?.Tags?.length > 0
                          ? "Manage Tag"
                          : "Add Tag"}
                      </p>
                    </AdDrawerStyledButton>
                  </Stack>
                </Stack>
              </>
            )}
            {/* )} */}
          </StyledAccordionDetails>
        </StyledAccordion>
      </Box>
      <AddTagPopover
        anchorEl={addTagPopupAnchorEl}
        handlePopoverClose={() => setAddTagPopupAnchorEl(null)}
        item={adDetailsData}
      />
    </>
  );
};

export default OrganizationBox;
